var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73204 4.12667L7.73206 4.12665C7.77233 4.0889 7.83561 4.09092 7.8734 4.13122C7.8734 4.13122 7.8734 4.13122 7.8734 4.13122L12.3734 8.93122L12.7146 8.61127L12.3734 8.93122C12.4094 8.96967 12.4094 9.02954 12.3734 9.06801C12.3733 9.06801 12.3733 9.06802 12.3733 9.06802L7.8734 13.868L7.87337 13.868C7.8356 13.9083 7.77237 13.9103 7.73209 13.8726L7.73208 13.8726C7.6917 13.8347 7.68978 13.7715 7.72744 13.7313L7.72749 13.7312L11.8428 9.34159L12.1634 8.99961L11.8428 8.65765L7.72749 4.26801L7.72749 4.26801C7.68971 4.22771 7.69176 4.16443 7.73204 4.12667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.38dc054041236f066464a2f0dac26001.svg";
export { ForwardRef as ReactComponent };